// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2p4NY","consentsList":"PatientConsents_consentsList__1jYoX","consentsListEmpty":"PatientConsents_consentsListEmpty__2TYNg"};